import React, { Component } from 'react';
import LoyaltyLanding from '../components/loyalty/loyaltyLanding';
import HowItWorks from '../components/loyalty/loyaltyHowItWorks';
import LoyaltyFlexContent from '../components/loyalty/loyaltyFlexContent';
import LoyaltyTiers from '../components/loyalty/loyaltyTiers';
import MembershipFAQ from '../components/loyalty/loyaltyFAQ';
import UtilityManager from '../managers/Utility';
import CustomBenefits from '../components/loyalty/customBenefits';
import { getParameterByName } from '../managers/Helpers';

class Setup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creatorData: {},
      transferToken: null,
      transferCookie: null,
      asset: null,
      showModal: true,
      benefits: [],
      language: 'en',
      membershipFeatures: [{
        featureId: 1, featureName: 'Referrals', featureDescription: 'Referral feature that allows brand customers to refer friends to the platform', isActive: true, tierId: null,
      }, {
        featureId: 2, featureName: 'Redemption', featureDescription: 'Redemption feature that allows brand customers to redeem points to get discount vouchers', isActive: true, tierId: null,
      }, {
        featureId: 3, featureName: 'ShopReferrals', featureDescription: 'Referral feature that allows brand customers to earn rewards from referral sales made in brand ecommerce shops.', isActive: true, tierId: null,
      }, {
        featureId: 4, featureName: 'BirthdayPoints', featureDescription: 'Allows the user to receive points during their birth month.', isActive: true, tierId: '3d54da1c-1041-4f71-a818-9aa6261bc74b',
      }, {
        featureId: 5, featureName: 'InstagramFollow', featureDescription: 'Allows the user to receive points for folliwing the users instagram.', isActive: true, tierId: null,
      }],
    };
  }

  setTransferToken = (token) => {
    Object.entries(localStorage).map((obj) => {
      const key = obj[0];
      if (key.includes('MEMBERSHIP_TRANSFER')) {
        sessionStorage.removeItem(key);
      }
      return true;
    });
    // force the one in the URL to be in memory
    this.setState({
      transferCookie: 'MEMBERSHIP_TRANSFER_' + token,
      transferToken: token,
    });
    // localStorage.setItem('MEMBERSHIP_TRANSFER_' + token, token);
  }

  componentDidMount() {
    document.title = process.env.CREATOR_SUBDOMAIN === 'account' ? 'ethos' : process.env.SITE_NAME + ' | Join the ' + process.env.DIGITAL_ASSET_TYPE;
    if (getParameterByName('id', window.location.href)) {
      this.setTransferToken(getParameterByName('id', window.location.href));
    } else if (process.env.EDROP_CLAIM_TOKEN) {
      this.setTransferToken(process.env.EDROP_CLAIM_TOKEN);
    } else {
      window.location.href = '/';
    }
  }

  loadTransferDetails = async (transferDetails) => {
    console.log('=== WE HAVE TRASNFER DETAILS ===');
    console.log(transferDetails);
    if (transferDetails.asset) {
      this.setState({
        asset: transferDetails.asset,
        showModal: false,
      });
    }
    // get any preview benefits
    const previewBenefits = await UtilityManager.getPreviewUtility(transferDetails.asset.assetId);
    if (previewBenefits && previewBenefits.length > 0) {
      this.setState({
        benefits: previewBenefits,
      });
    }
  }

  componentWillUnmount() {
    document.title = process.env.SITE_NAME;
  }

  render() {
    const {
      language, showModal, transferCookie, transferToken, membershipFeatures,
    } = this.state;
    return (
      <div>
        <LoyaltyLanding lang={language} onTransferDetailsLoaded={(transferDetails) => this.loadTransferDetails(transferDetails)} transferCookie={transferCookie} transferToken={transferToken} />
        
        <HowItWorks lang={language} />

        {/* <LoyaltyBenefits lang={language} /> */}

        <LoyaltyFlexContent lang={language} />
        <div className="custom-benefits-outer">
          <CustomBenefits features={membershipFeatures} readOnly />
          {/* <ClassicSixRedemptionCenter features={membershipFeatures} readOnly /> */}
          <div>
            <div className="benefits-summary__header">
              <div className="benefits-summary__header--title">
                <span>Redeem Points</span>
              </div>
            </div>
            
            <div className="benefits-summary__vouchers">
              <div className="benefits-summary__vouchers--header">Redeeming your points is super easy. As soon as you get to a certain level of points, redeem them for a voucher!</div>
              <div className="custom-benefits-wrapper">
                <div className="benefits-highlighted">
                  <div className="benefits-highlighted__item col-14">
                    <div className="benefit-voucher__price">
                      <strong>$5</strong>
                      {' '}
                      voucher
                    </div>
                    <div className="benefit-voucher__points">
                      250 points
                    </div>
                  </div>
                  <div className="benefits-highlighted__item col-14">
                    <div className="benefit-voucher__price">
                      <strong>$10</strong>
                      {' '}
                      voucher
                    </div>
                    <div className="benefit-voucher__points">
                      500 points
                    </div>
                  </div>
                  <div className="benefits-highlighted__item col-14">
                    <div className="benefit-voucher__price">
                      <strong>$20</strong>
                      {' '}
                      voucher
                    </div>
                    <div className="benefit-voucher__points">
                      1000 points
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <LoyaltyTiers lang={language} />

        <div className="benefits-summary__header">
          <div className="benefits-summary__header--title">
            <span>FAQ</span>
          </div>
        </div>
        <div className="storefront-faq">
          <MembershipFAQ noHeader lang={language} />
        </div>
      </div>
    );
  }
}

export default Setup;
